import { Center, Flex } from "@chakra-ui/react";
import CDS from "design-system";
import { useState } from "react";
import { NewHireJourneyId } from "models/newHire";
import { useNewHireJourneyMeetingsQuery } from "features/Resources/Meeting/hooks";
import MeetingsScheduleView from "features/NewHireJourney/Components/MeetingsSchedule/MeetingsScheduleView";
import MeetingDrawer from "features/NewHireJourney/Components/MeetingsSchedule/MeetingDrawer";
import { BulkScheduleView } from "features/BulkSchedule";
import { useCurrentUserQuery } from "features/User/hooks";

interface MeetingsByListProps {
  newHireJourneyId: NewHireJourneyId;
  startDate?: Date;
  newHireId?: string;
}

export default function MeetingsByList({ newHireJourneyId, startDate, newHireId }: MeetingsByListProps) {
  const [showBulkSchedule, setShowBulkSchedule] = useState(false);
  const [selectedPrefixId, setSelectedPrefixId] = useState<string | null>(null);
  const { data: currentUser } = useCurrentUserQuery();
  const timezone = currentUser?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  const { data: meetings, isLoading } = useNewHireJourneyMeetingsQuery(newHireJourneyId);

  // Re-derive each render so attendee edits (via the drawer) reflect after refetch.
  const selectedMeeting = meetings?.find((m) => m.prefixId === selectedPrefixId) ?? null;

  if (isLoading) {
    return (
      <Center mt="4">
        <CDS.Text14 color="fg.emphasized">Loading...</CDS.Text14>
      </Center>
    );
  }

  return (
    <Flex direction="column" width="100%">
      <MeetingsScheduleView
        meetings={meetings}
        onExpand={setSelectedPrefixId}
        onScheduleAll={() => setShowBulkSchedule(true)}
        startDate={startDate}
      />
      <MeetingDrawer meeting={selectedMeeting} onClose={() => setSelectedPrefixId(null)} newHireId={newHireId} />
      <BulkScheduleView
        journeyId={String(newHireJourneyId)}
        timezone={timezone}
        isOpen={showBulkSchedule}
        onClose={() => setShowBulkSchedule(false)}
      />
    </Flex>
  );
}
